<template>
  <div class="jieshao">
    <p class="title"><span>{{textMarkerList[0].title}}</span></p>
    <hr>

    <div class="content">
      <div>
        {{textMarkerList[0].content}}

      </div>
    </div>

  </div>

</template>

<script>
  export default {
    name: 'jieshao',
    props: {
      textMarkerList: {
            type: Array
        },
        // pluginIndex: {
        //     type: String
        // }
    },
    data () {
      return {
        activeIndex: 0,
        arr: [ 1, 2,3,4 ,5, 6, 7]
      }
    },
    created () {
      console.log(this.pluginJson)
    },
    mounted () {

    },
    watch: {
      textMarkerList: {
        handler(newvalue,oldvalue){
          console.log('pluginJson',this.textMarkerList)
        },
        deep: true
      }
    },
    methods: {

    }
  }

</script>

<style lang="scss" scoped>
  @function rem($px) {
    @return $px * (1/40) * 1rem;
  }
  .jieshao{
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    .title{
      font-size: rem(28);
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      /*color: #008C8C;*/
      color: var(--body-color);
      line-height: rem(32);
      margin-bottom: rem(20);
      text-align: center;
      padding-top: rem(40);
      span{
        display:inline-block;
        width: rem(168);
        height: rem(76);
        line-height: rem(35);
      }
    }
    .content{
      width: 100%;
      text-align: center;
      div{
        width: rem(900);
        margin: auto;
      }
    }
  }




</style>
